import { Base } from './base';

export class Company extends Base {
    CompanyID?: number;
    AddressID?: string;
    Title?: string;
    Identifier?: string;
    BankAccount?: string;
    Date?: Date;

    // Constructors
    constructor(companyId?: number, title?: string) {
        super();
        this.CompanyID = companyId;
        this.Title = title;
    }
}
